const ApiToolTips = {
    'body':'',
    'start':function(){
        let self = this;
        self.init();
        self.setTooltip();
    },
    'setTooltip': function(){
        let self = this;
        let tooltipTriggers = self.body.find('[tooltip-trigger]');

        tooltipTriggers.each(function(){
            let tooltipTrigger = $(this)
            tooltipTrigger.on('mouseover', function(){
                let onMouseOver = $(this);
                let triggerName = onMouseOver.attr('tooltip-trigger');
                let tooltipTarget = self.body.find('[tooltip-target="'+triggerName+'"]');
                let tooltipValue = onMouseOver.attr('tooltip-value');
                let items = tooltipValue.split('|');
                let html = '<div class="text-smallest text-right">'+items[0]+'</div>';
                html += '<div class="text-smallest text-right">'+items[1]+'</div>';
                tooltipTarget.html(html);
                // console.log('hover');
            });

            tooltipTrigger.on('mouseout', function() {
                let onMouseOut = $(this);
                let triggerName = onMouseOut.attr('tooltip-trigger');
                let tooltipTarget = self.body.find('[tooltip-target="'+triggerName+'"]');
                tooltipTarget.text(''); // clear text
            });
        });

    },

    'init':function(){
        let self = this;
        self.body = $('body');
    }
}

$(document).ready(function(){
    ApiToolTips.start();
});
